import type { FieldValidation } from '@rjsf/utils';
import { TextField } from '@material-ui/core';
import { blacklistedNames, blacklistedSuffixes } from './constants';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export const ValidateApplicationName = (props: FieldExtensionComponentProps<string>) => {

  const {
    onChange,
    required,
    schema: { title, description },
    rawErrors,
    formData,
    uiSchema: { 'ui:autofocus': autoFocus },
    idSchema,
    placeholder,
  } = props;

  return (
    <TextField
      id={idSchema?.$id}
      label={title}
      placeholder={placeholder}
      helperText={description}
      required={required}
      value={formData ?? ''}
      onChange={({ target: { value } }) => onChange(value)}
      margin="normal"
      error={rawErrors?.length > 0 && !formData}
      inputProps={{ autoFocus }}
    />
  );
};


export const validateApplicationNameValidation = (
  value: string,
  validation: FieldValidation,
) => {
  const snakeCase = /^[a-z0-9]([-a-z0-9]*[a-z0-9])?$/g.test(value);

  const blackListed = blacklistedNames.includes(value)

  const blacklistedSuffix = blacklistedSuffixes.find((suffix) => value.endsWith(suffix))

  if (blackListed) {
    validation.addError(
      `Application name ${value} is blacklisted.`
    );
    return;
  }

  if (blacklistedSuffix) {
    validation.addError(
      `The application name cannot end with ${blacklistedSuffix}`
    );
    return;
  }
  
  if (!snakeCase) {
    validation.addError(
      `Names can only contain lowercase letters, numbers, and hyphens. The name must not start or end with a hyphen. (RFC 1123)`,
    );
  }
}
